<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Account/Firm Data</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Account General Questions.</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none" v-if="canExport">
          <button
              @click="exportData"
              :disabled="!selectedItems.length"
              type="button"
              :class="[
                  'block rounded-md px-3 py-2 text-center text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
                   selectedItems.length
                   ? 'bg-gray-600 text-white hover:bg-gray-500 focus-visible:outline-gray-600'
                   : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              ]"
          >
            Export
          </button>
        </div>
      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                  <input
                      type="checkbox"
                      @change="toggleSelectAll"
                      :checked="allSelected"
                  />
                </th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Account name</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">FCA Firm Reference Number</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Companies House Number</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Please tell us your firm type?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">What is your phone number?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Where are you based?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">How many employees / staff?</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">How large is your client base?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">What is the average age of your clients?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">What is your Annual Recurring Revenue?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which level of annual turnover best matches last years figures?</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Assets Under Management?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">What is your current or last year EBITDA?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">What fee structure do you use?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which platform do you use?</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which compliance firm do you use?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which practice management (back-office) technology do you use?</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Please add your practice management tech</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which attitude to risk technology do you use?</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 whitespace-nowrap">Which cashflow modelling technology do you use?</th>

                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Created at</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <input
                      type="checkbox"
                      :value="item.id"
                      @change="toggleSelection(item.id)"
                      :checked="selectedItems.includes(item.id)"
                  />
                </td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.name }}</td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.fca_firm_reference_number }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.companies_house_number }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.firm_type_name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.phone_number }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.location }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.staff }}</td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.client_base }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.average_age_clients }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.annual_recurring_revenue }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.turnover }}</td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.assets_under_management }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.ebitda }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.fee_structure }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.platform }}</td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.compliance_firm }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.back_office }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.practice_management_technology }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.risk_technology }}</td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.cashflow_technology }}</td>


                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.created_at }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EyeIcon} from "@heroicons/vue/20/solid";
import SearchComponent from "../SearchComponent.vue";

export default {
  name: "AccountGeneralQuestionsIndexComponent",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
      selectedItems: [],
      allIds: [],
      allSelected: false,
    }
  },
  components: {
    PaginationComponent,
    EyeIcon,
    SearchComponent,
  },
  computed: {
    canExport() {
      return this.$store.state.account.features.access_account_firm_data_export;
    },
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  methods: {
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/accounts/general-questions/index?page=${page}`, {
        params: {'search_text': this.searchText}
      }).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
        this.fetchAllIds();
        if (this.allSelected) {
          this.selectedItems = [...new Set([...this.selectedItems, ...this.items.map(item => item.id)])];
        }
      }).catch((error) => {
        console.log('error', error)
      })
    },
    exportData() {
      axios.post(
          '/member-firm/accounts/general-questions/export',
          {
            account_ids: this.selectedItems
          },
          {
            responseType: 'blob'
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export_general_questions.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$notify({ type: "success", title: "Successfully", text: 'Download in process' });
      }).catch((error) => {
        console.log('error', error);
      });
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = [];
        this.allSelected = false;
      } else {
        this.selectedItems = [...this.allIds];
        this.allSelected = true;
      }
    },
    toggleSelection(id) {
      if (this.selectedItems.includes(id)) {
        this.selectedItems = this.selectedItems.filter(itemId => itemId !== id);
      } else {
        this.selectedItems.push(id);
      }

      if (this.selectedItems.length !== this.allIds.length) {
        this.allSelected = false;
      }
    },
    fetchAllIds() {
      axios.get(`/member-firm/accounts/general-questions/ids`, {
        params: { search_text: this.searchText }
      }).then((res) => {
        this.allIds = res.data.data;
      }).catch((error) => {
        console.log("error", error);
      });
    },
  },
  created() {
    this.getItems();
  },
}
</script>